export const toRem = (px: number) => `${px / 16}rem`;

export const ScrollBarAdjustment = 'calc(100vw - 100%)';

export const ImageWithCorrectAspectRatioStyle = {
    width: '100%',
    height: 'auto',
    aspectRatio: 'attr(width) / attr(height)',
};
